import { OrderType } from '../orders/order-type.enum';

/**
 * Order types that have a cart. A cart is kept separately for pre-order and
 * re-order; other {@link OrderType} values are unsupported.
 */
export type CartOrderType = OrderType.PreOrder | OrderType.ReOrder;

/** Runtime values for {@link CartOrderType} (path validation, etc.). */
export const CART_ORDER_TYPES: readonly CartOrderType[] = [OrderType.PreOrder, OrderType.ReOrder];
